import { ReactNode } from 'react';

interface TopBarContentProps {
	children: ReactNode;
}

const TopBarContent = ({ children }: TopBarContentProps) => {
	return <>{children}</>;
};

export default TopBarContent;
